import { render, staticRenderFns } from "./res.vue?vue&type=template&id=4d34c252&scoped=true&"
import script from "./res.vue?vue&type=script&lang=js&"
export * from "./res.vue?vue&type=script&lang=js&"
import style0 from "./res.vue?vue&type=style&index=0&id=4d34c252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d34c252",
  null
  
)

component.options.__file = "res.vue"
export default component.exports